export const enableUserAddedSelectionContext = (appName: string) =>
  appName === 'weblab2';
